var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled / Key"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_COLOR",
    d: "M18.3333 7.39586C18.3333 10.56 15.7683 13.125 12.6041 13.125C12.2389 13.125 11.8818 13.0904 11.5355 13.0251L10.7539 13.9045C10.6806 13.9869 10.5907 14.0529 10.49 14.0981C10.3894 14.1433 10.2803 14.1667 10.17 14.1667H8.95829V15.4687C8.95829 15.9002 8.60852 16.25 8.17704 16.25H6.87496V17.5521C6.87496 17.9836 6.52519 18.3333 6.09371 18.3333H2.44788C2.0164 18.3333 1.66663 17.9836 1.66663 17.5521V15.0111C1.66663 14.8039 1.74895 14.6052 1.89543 14.4586L7.16243 9.19166C6.97613 8.62675 6.87496 8.02313 6.87496 7.39582C6.87496 4.2317 9.43997 1.66669 12.6041 1.66666C15.7776 1.66662 18.3333 4.22235 18.3333 7.39586ZM12.6041 5.83332C12.6041 6.69628 13.3037 7.39582 14.1666 7.39582C15.0296 7.39582 15.7291 6.69628 15.7291 5.83332C15.7291 4.97037 15.0296 4.27082 14.1666 4.27082C13.3037 4.27082 12.6041 4.97037 12.6041 5.83332Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyDeprecated);
export default __webpack_public_path__ + "static/media/key_deprecated.9624c246766d94f7c5186f3d91a2ee38.svg";
export { ForwardRef as ReactComponent };